export const customerStatus = value => ({active:'Aktif',inactive:'Pasif',disabled:'Pasif',read_only:'İşlem kısıtlı',pending:'Beklemede',approved:'Onaylandı'})[value] || value || 'Belirtilmedi';
export const customerAccountType = value => ({demo:'Demo',real:'Gerçek'})[value?.toLowerCase()] || value || '—';
export const customerBalance = row => {
  if(row.balance===undefined||row.balance===null)return '—';
  const options={minimumFractionDigits:2,maximumFractionDigits:2};
  if(row.currency&&/^[A-Z]{3}$/.test(row.currency))Object.assign(options,{style:'currency',currency:row.currency});
  return Number(row.balance).toLocaleString('tr-TR',options);
};
export const hasCRMFieldPermission = (permissions, key) => permissions.some(value=>value==='*'||value==='crm.business.*'||value===key);